export const AI_VERIFICATION_PROMPTS = {
  damaged_item_claim: (categoryList: string) =>
    `You are classifying an image uploaded as part of a package protection claim. The customer claims their item arrived damaged or broken.

Classify this image into exactly one of these categories: ${categoryList}.

- "item": The image shows the claimed product in a damaged, broken, or defective state.
- "packaging": The image shows a shipping container, shipping box, mailer, or packaging material.

If the image does not clearly fit any category (e.g. it's a screenshot, a selfie, text, unrelated content), reject it by setting category to null.`,
} as const;
